import { ROW_HEIGHT } from "../../../../constants/constants";
import {
  TAGHIGHLIGHT_BACKDROP_HEIGHT,
  TAGHIGHLIGHT_BACKDROP_MARGIN_TOP,
  TAGHIGHLIGHT_EXPANDED_OFFSET_TOP,
} from "../../HubletView/SingleTimeline/TagHighlightTimelineBackdrop";

import { safariOffset } from "./safariOffset";

// Colors for visual display
// const segmentColor = "#5C8EC5";
export const skuSegmentColor = "#3f6d90";
export const skuSegmentColorTransparent = "#909fb0";
export const loadingSubtimelineBackgroundColor = "#f5f5f5";
export const subTimelineLoadingDashColor = "#b0b0b0"; // Darker color for better visibility

export const ONE_SKUOPERATOR_TIMELINE_HEIGHT =
  TAGHIGHLIGHT_BACKDROP_HEIGHT + TAGHIGHLIGHT_BACKDROP_MARGIN_TOP;

export const TIMELINES_OFFSET_TOP =
  ROW_HEIGHT +
  TAGHIGHLIGHT_BACKDROP_MARGIN_TOP +
  TAGHIGHLIGHT_EXPANDED_OFFSET_TOP;

/** for each sub-timeline above this one, add 1x timeline height offset */
export function getTimelineOffsetY(numAbove: number): number {
  return (
    safariOffset +
    TIMELINES_OFFSET_TOP +
    (ONE_SKUOPERATOR_TIMELINE_HEIGHT *
      (numAbove +
        1) /* + 1 => always show tag-highlight timeline above these other sub-timelines */ +
      0.5)
  );
}

export const SEGMENT_MARGIN = 2;
